import { render, staticRenderFns } from "./scoreboard_darts.vue?vue&type=template&id=a4f9fc74&scoped=true&"
import script from "./scoreboard_darts.vue?vue&type=script&lang=js&"
export * from "./scoreboard_darts.vue?vue&type=script&lang=js&"
import style0 from "./scoreboard_darts.vue?vue&type=style&index=0&id=a4f9fc74&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a4f9fc74",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {EventTime: require('/var/web/bet777.es/components/event_time.vue').default})
